import { ENDPOINTS } from "../../constant/routes";
import { request } from "../../services/requests";

export interface ChatMonitorRow {
  chat_id: string;
  listing_id: string;
  listing_name: string | null;
  buyer_id: string;
  buyer_username: string | null;
  buyer_email: string | null;
  seller_id: string;
  seller_username: string | null;
  seller_email: string | null;
  buyer_status: string | null;
  seller_status: string | null;
  created_at: string;
  modified_at: string;
  last_message_at: string | null;
}

export interface ChatHistoryItem {
  message_id: string;
  sender: string | null;
  message_type: string;
  content: string;
  timestamp: string | null;
}

export interface ChatMonitorStats {
  total: number;
  active: number;
  new_24h: number;
}

export interface ChatHistoryResponse {
  chat_id: string;
  messages: ChatHistoryItem[];
  /** Older messages exist beyond the ones returned */
  truncated?: boolean;
}

/** The most recently active chats, optionally filtered by buyer / seller
 * (username, email or user id). */
export const getMonitoredChats = (token: string, params: { limit: number; buyer?: string; seller?: string }) =>
  request(token).get<ChatMonitorRow[]>(`${ENDPOINTS.CHATS}/monitor`, {
    params: {
      limit: params.limit,
      ...(params.buyer ? { buyer: params.buyer } : {}),
      ...(params.seller ? { seller: params.seller } : {}),
    },
  });

export const getChatMonitorStats = (token: string) => request(token).get<ChatMonitorStats>(`${ENDPOINTS.CHATS}/monitor/stats`);

export const getChatHistory = (chatId: string, token: string) =>
  request(token).get<ChatHistoryResponse>(`${ENDPOINTS.CHATS}/${chatId}/history`);
